import { sepolia as viemEthereumSepolia } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const ethereumSepolia = {
  displayName: 'Ethereum Sepolia',
  runtime: 'evm',
  viemChain: viemEthereumSepolia,
  isSupported: false,
  isMainnet: false,
  // Safe STS support (owners discovery + propose/confirm/pending) is keyed off
  // `services.safe` across ALL recognised chains, not just supported ones —
  // sepolia stays in the Safe set for multi-sig testing (see packages/multi-sig).
  services: defaultServices({ safe: { shortName: 'sep' } }),
} as const satisfies AllChainConfig<'evm', false>;
